<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M14.409 16.317 13.392 15.3H10.8c0-.99-.81-1.8-1.8-1.8s-1.8.81-1.8 1.8H4.05c-.747 0-1.35-.603-1.35-1.35V10.8c.99 0 1.8-.81 1.8-1.8s-.81-1.8-1.8-1.8V4.608L1.683 3.591l.954-.954.459.459 12.267 12.267-.954.954ZM15.3 7.2V4.05c0-.747-.603-1.35-1.35-1.35H10.8c0-.99-.81-1.8-1.8-1.8s-1.8.81-1.8 1.8H4.608L15.3 13.392V10.8c.99 0 1.8-.81 1.8-1.8s-.81-1.8-1.8-1.8Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
